export const Sustainability_Q2_Check_Details = [
  {
    CheckId: "unused_amazon_machine_images",
    Description: "Unused Amazon Machine Images (AMIs) must be removed",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unassociated_internet_gateway",
    Description: "Check for unused VPC Internet Gateways (IGWs).",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "underutilized_dynamodb_table_writes",
    Description:
      "Identify any Amazon DynamoDB tables with underutilized write capacity, by downsizing the capacity can lower the cost of the monthly AWS bill",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_idle_instances_check",
    Description: "RDS Idle DB Instances",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unassociated_egress_only_internet_gateway",
    Description: "Unused Egress Only Internet Gateways",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unassociated_ebs_volume",
    Description: "Check for unused EBS volumes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unassociated_launch_configuration",
    Description: "Check for unassociated launch configurations",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unused_aws_workspace",
    Description: "Unused AWS WorkSpaces",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "instance_in_autoscaling_group_check",
    Description: "Instance in autoscaling group",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unused_kms_keys",
    Description: "Check for unused KMS keys",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elasticsearch_cluster_idle_check",
    Description: "Idle Elasticsearch Clusters",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unassociated_network_interface",
    Description: "Check for unassociated Network Interfaces",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "underutilized_dynamodb_table_reader",
    Description:
      "Identify any Amazon DynamoDB tables with underutilized read capacity, by downsizing the capacity  can lower the cost of the monthly AWS bill",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Sustainability_Q2__unused_amazon_machine_images = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unused_amazon_machine_images",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "87632039-40db-4f26-8529-0ce436ba9e1e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Unused Amazon Machine Images (AMIs) result in wasted cloud spend. This check verifies if there are any unused AMIs in your AWS Accounts.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-0a8d4563854aec173",
      ResourceType: "Image",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_amazon_machine_images",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "c5fd4230-2f7d-47e6-aebd-90560503f551",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Unused Amazon Machine Images (AMIs) result in wasted cloud spend. This check verifies if there are any unused AMIs in your AWS Accounts.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-092c18574fce16603",
      ResourceType: "Image",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Sustainability_Q2__unassociated_internet_gateway = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "7a502aea-e9b2-4923-9162-a80577f46832",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-039cbf0db07cc4c6f",
      ResourceType: "InternetGateway",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "9b71f25a-2bc7-45f5-8632-0655698431af",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-0082c00bafcc56797",
      ResourceType: "InternetGateway",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "e13ff504-eb4d-4bfd-bf6d-dc885781a7c1",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-0985d6f4e65f730ed",
      ResourceType: "InternetGateway",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "e810bb02-9ffe-4c93-95fb-c9b73be4690b",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-0f4489b8c0fa15ad2",
      ResourceType: "InternetGateway",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Sustainability_Q2__underutilized_dynamodb_table_writes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "underutilized_dynamodb_table_writes",
      CreatedAt: "2023-04-25 12:24:10",
      FindingId: "e96f8157-a890-47c1-9b1a-2ee8d1e63815",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify any Amazon DynamoDB tables with underutilized write capacity, by downsizing the capacity can lower the cost of the monthly AWS bill",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "d0d951e9-d147-4521-913e-40d536a29a69",
      ResourceType: "DynamoDbTable",
      Severity: "Medium",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Sustainability_Q2__rds_idle_instances_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_idle_instances_check",
      CreatedAt: "2023-04-25 12:23:32",
      FindingId: "d6e3ef08-0833-44fc-9dc4-5c33ec6efcf1",
      Metadata: {
        TaskRefId: "1c1e0017-c0a7-4091-b5fa-c22d0581d5c1",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify any Amazon RDS database instances that appear to be idle",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_idle_instances_check",
      CreatedAt: "2023-04-25 12:23:32",
      FindingId: "e1a45899-2516-4221-9837-f62e9b530423",
      Metadata: {
        TaskRefId: "1c1e0017-c0a7-4091-b5fa-c22d0581d5c1",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify any Amazon RDS database instances that appear to be idle",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Sustainability_Q2__unassociated_egress_only_internet_gateway = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_egress_only_internet_gateway",
      CreatedAt: "2023-04-25 12:25:12",
      FindingId: "1621ec4f-2f42-450a-93ab-24d2c55686b9",
      Metadata: {
        TaskRefId: "986eef83-9ae8-47d6-967e-086a2065eec1",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify any unused  VPC Egress-Only Internet Gateways (EIGWs)",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eigw-0ded9ae6226e25456",
      ResourceType: "EgressOnlyInternetGateway",
      Severity: "Low",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Sustainability_Q2__unassociated_ebs_volume = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "0f5b400a-7c19-4213-84d9-3dd7b267f143",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-00390a16574adf858",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "85bfd7f2-fc76-4034-8b30-fa84a41ddccd",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-06ffbd8c4acb516a1",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "b87d1161-83dc-4f39-8466-490468e4eb6f",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-0faf25aeab3cb0efa",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "e521594a-32a0-4af1-a6d0-8494dd058ac4",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-0ea6b0db4290bf8cb",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Sustainability_Q2__unassociated_launch_configuration = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_launch_configuration",
      CreatedAt: "2023-04-25 12:24:46",
      FindingId: "1cdefe92-9cfd-498f-8b8b-de13f03a2e6b",
      Metadata: {
        TaskRefId: "e41dad68-9cef-4c78-9657-a148a1237d62",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "It is a best practice to remove Launch Configuration templates that are not used anymore by AWS Auto Scaling Groups.  This check identifies unassociated launch configurations.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "HumanTech-Production-UnusedResourcesNonCompliant-109RHAL4LPGV7-UnassociatedLaunchConfig-5lYhZBuFmXDP",
      ResourceType: "LaunchConfiguration",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Sustainability_Q2__unused_aws_workspace = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Sustainability_Q2__instance_in_autoscaling_group_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "instance_in_autoscaling_group_check",
      CreatedAt: "2023-04-25 12:24:07",
      FindingId: "386c15ff-9d80-4d33-8d04-8ced7deabe85",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Make sure every instance is launched within an AWS Auto Scaling Group in order to help improve the availability and scalability of your web applications during instance failures or denial-of-service attacks (DoS, DDoS).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0eb9f9cc0b178be09",
      ResourceType: "Instance",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "instance_in_autoscaling_group_check",
      CreatedAt: "2023-04-25 12:24:07",
      FindingId: "a5473ba0-b6db-426e-856c-64c45daa56f8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Make sure every instance is launched within an AWS Auto Scaling Group in order to help improve the availability and scalability of your web applications during instance failures or denial-of-service attacks (DoS, DDoS).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-04b1c4e4f9284d09a",
      ResourceType: "Instance",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "instance_in_autoscaling_group_check",
      CreatedAt: "2023-04-25 12:24:07",
      FindingId: "c72a9a36-ad05-4ca9-bf67-8398ad91bf0f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Make sure every instance is launched within an AWS Auto Scaling Group in order to help improve the availability and scalability of your web applications during instance failures or denial-of-service attacks (DoS, DDoS).",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0e72da0097f2af649",
      ResourceType: "Instance",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 3,
};
export const Sustainability_Q2__unused_kms_keys = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unused_kms_keys",
      CreatedAt: "2023-04-25 12:25:08",
      FindingId: "d814c3a3-fa26-4f18-bf49-6248a7dc0553",
      Metadata: {
        TaskRefId: "cd57bf21-9bf6-464a-9660-8029e4f54b92",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore. This check identifies unused KMS keys in your account so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "fbbb8caa-260c-43f1-b460-94eef2dd8a28",
      ResourceType: "KMSKey",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_kms_keys",
      CreatedAt: "2023-04-25 12:25:08",
      FindingId: "aefe7374-a674-462a-8506-133daabf125f",
      Metadata: {
        TaskRefId: "cd57bf21-9bf6-464a-9660-8029e4f54b92",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore. This check identifies unused KMS keys in your account so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "66d0e6fe-1ae2-4919-85b8-6966f7e2c1c7",
      ResourceType: "KMSKey",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Sustainability_Q2__elasticsearch_cluster_idle_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Sustainability_Q2__unassociated_network_interface = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "4dc12c09-c25e-4519-99b3-5c36ac4866cb",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-0d88e9ea9dacaa5f6",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "31988e6d-d26d-494f-a8a2-78d396ce699e",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-06aa28bda6f6a2f5a",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "52055a1d-6dd0-40c4-b037-df66cc0ed048",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-0fe2432a3cff11789",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "5bd5e2fb-fc32-4e79-9961-3a8677217dcc",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-006fc56ce398feeef",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "c98efed2-23cd-48ef-bfd1-5db269189440",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-077cb96eb994b4e1a",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "f5690d9e-b2a8-4036-8702-a44618947886",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-07c46d78936f2fdcd",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Sustainability_Q2__underutilized_dynamodb_table_reader = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "underutilized_dynamodb_table_reader",
      CreatedAt: "2023-04-25 12:24:10",
      FindingId: "31c15334-e8de-4de6-a301-9d10c846381a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_user",
      Recommendation:
        "Identify any Amazon DynamoDB tables with underutilized read capacity, by downsizing the capacity  can lower the cost of the monthly AWS bill",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "d0d951e9-d147-4521-913e-40d536a29a69",
      ResourceType: "DynamoDbTable",
      Severity: "Medium",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};

export const Sustainability_Q3_Check_Details = [
  {
    CheckId: "rds_aurora_performance_insights_check",
    Description: "Enable performance insights for RDS Aurora databases",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_performance_insights_enabled_check",
    Description: "Enable Performance Insights for RDS databases",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Sustainability_Q3__rds_aurora_performance_insights_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Sustainability_Q3__rds_performance_insights_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_performance_insights_enabled_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "f66338cd-d456-49b2-9ca3-f4aac735f5b8",
      Metadata: {
        TaskRefId: "830b7368-464b-4266-9b54-591671ad35e5",
      },
      PillarId: "sustainability",
      QuestionId: "sus_software",
      Recommendation:
        "Performance Insights feature allows you to obtain a better overview of the performance of your AWS RDS database instances have and help you to identify potential performance issues. This check verifies if Performance Insights are enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Sustainability_Q4_Check_Details = [
  {
    CheckId: "ecr_image_lifecycle_policy_check",
    Description: "Lifecycle policy for Amazon ECR image repository",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Sustainability_Q4__ecr_image_lifecycle_policy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ecr_image_lifecycle_policy_check",
      CreatedAt: "2023-04-25 12:24:50",
      FindingId: "66e119f0-7fcc-4abd-b44d-4302cd17b177",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "sustainability",
      QuestionId: "sus_data",
      Recommendation:
        "Ensure there is a lifecycle policy defined for each Amazon ECR image repository in order to automatically remove untagged and old container images.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ecr:us-east-1:181570489212:repository/warf-repo-ba272900-e354-11ed-860e-0e88695980d3",
      ResourceType: "Repository",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const sustainabilityCheckFindings = {
  [`sus_user_unused_amazon_machine_images`]:
    Sustainability_Q2__unused_amazon_machine_images,
  [`sus_user_unassociated_internet_gateway`]:
    Sustainability_Q2__unassociated_internet_gateway,
  [`sus_user_underutilized_dynamodb_table_writes`]:
    Sustainability_Q2__underutilized_dynamodb_table_writes,
  [`sus_user_rds_idle_instances_check`]:
    Sustainability_Q2__rds_idle_instances_check,
  [`sus_user_unassociated_egress_only_internet_gateway`]:
    Sustainability_Q2__unassociated_egress_only_internet_gateway,
  [`sus_user_unassociated_ebs_volume`]:
    Sustainability_Q2__unassociated_ebs_volume,
  [`sus_user_unassociated_launch_configuration`]:
    Sustainability_Q2__unassociated_launch_configuration,
  [`sus_user_unused_aws_workspace`]: Sustainability_Q2__unused_aws_workspace,
  [`sus_user_instance_in_autoscaling_group_check`]:
    Sustainability_Q2__instance_in_autoscaling_group_check,
  [`sus_user_unused_kms_keys`]: Sustainability_Q2__unused_kms_keys,
  [`sus_user_elasticsearch_cluster_idle_check`]:
    Sustainability_Q2__elasticsearch_cluster_idle_check,
  [`sus_user_unassociated_network_interface`]:
    Sustainability_Q2__unassociated_network_interface,
  [`sus_user_underutilized_dynamodb_table_reader`]:
    Sustainability_Q2__underutilized_dynamodb_table_reader,
  [`sus_software_rds_aurora_performance_insights_check`]:
    Sustainability_Q3__rds_aurora_performance_insights_check,
  [`sus_software_rds_performance_insights_enabled_check`]:
    Sustainability_Q3__rds_performance_insights_enabled_check,

  [`sus_data_ecr_image_lifecycle_policy_check`]:
    Sustainability_Q4__ecr_image_lifecycle_policy_check,
};
